import React, { FunctionComponent, useContext } from 'react'
import {observer} from 'mobx-react'
import {Cell} from './Cell'
import SchemerModel from '../../core/SchemerModel'
import {TableStore, TableStoreContext} from './TableStore'

const REUSE_DOM_NODES = false

export interface CellsProps {
  isHeaderRow?: boolean
  rowId: string
  row: SchemerModel|undefined
  sortField?: string
  sortDir?: 'asc'|'desc'
  onChangeSort?: (newSortField: string, newSortDir: 'asc'|'desc') => void
}

export const Cells: FunctionComponent<CellsProps> = observer(({
  isHeaderRow,
  rowId,
  row,
  sortField,
  sortDir,
  onChangeSort
}) => {
  const tableStore: TableStore = useContext(TableStoreContext)

  if (
    !row
    || !tableStore
    || !tableStore.visibleCells
  ) {
    return null
  }
  
  return (
    <>
      {tableStore.visibleCells.visibleColKeys.map((colKey, visibleColIndex) => (
        <Cell 
          key={`${rowId}_${REUSE_DOM_NODES ? visibleColIndex : colKey}`}
          row={row}
          columnKey={colKey}
          isColHeader={isHeaderRow}
          sortField={sortField}
          sortDir={sortDir}
          onChangeSort={onChangeSort}
        />
      ))}
    </>
  )
})

